// extracted by mini-css-extract-plugin
export default {"banner":"ErrorBanner_banner__ehE+2","icon":"ErrorBanner_icon__e4j93","text":"ErrorBanner_text__tSZxh","retry":"ErrorBanner_retry__gMCrn"};